module.exports = __webpack_public_path__ + "img/usinfo.48fff72f.jpg";